import './Total.css';

const Total = () => {
    return ( 
        <div className="total">
            <input type="submit"/>
        </div>
     );
}

// value="Total amount &nbsp; $20.56" 
 
export default Total;